// import JSDisplayObject from "./JSDisplayObject";
import { useEffect } from "react";
import { js_utils } from "../utils/frfr-js-utils";
import { _zzsurvey_utils_fix_val_for_display_in_table, _zzsurvey_utils_translate } from "../utils/zz/zz-zzsurvey-utils";
import JSDisplayValue from "./JSDisplayValue";
import TableGenerator from "./TableGenerator";


const ViewGeneratorSimple = (props) => {
  const {
    viewDefinition,
    viewArr,
    fetching,
    jsxSpinner, // TODO
  } = props;
  const {
    cbEntityKeyExtractor,
    cbEntityColumnValExtractor,
    cbEntityColumnValCustomDisplay, //
    cbRefresh,
    cbEntityActionsJsx,
    options,
  } = viewDefinition;

  let table_additional_row_blueprint = {};
  if (js_utils.is_object(viewDefinition.table_additional_row_blueprint)) {
    table_additional_row_blueprint = viewDefinition.table_additional_row_blueprint;
  }

  let table_additional_column_keys = [];
  if (Array.isArray(viewDefinition.table_additional_column_keys)) {
    table_additional_column_keys = viewDefinition.table_additional_column_keys;
  }

  let is_show_entity = true;
  if (options?.entity_col_disabled === true) {
    is_show_entity = false;
  }
  let showSelectable = false;
  if (options?.showSelectable === true) {
    showSelectable = true;
  }

  useEffect(() => {
    cbRefresh();
  }, []);


  let arr = [];
  let jsxZero = null;
  let jsxError = null;
  if (fetching === true) {

  } else {
    if (Array.isArray(viewArr)) {
      arr = viewArr;
      if (arr.legth === 0) {
        jsxZero = (
          <div className="view-generator-simple__zero-items">No items to show</div>
        );
      }
    } else {
      // ERROR
      jsxError = (
        <div className="frfr-js-display-velue-error-msg"><span>ERROR: viewArr is not an Array!</span></div>
      );
    }
  }


  //
  let _tableBlueprint_columns_entity = [];
  if (is_show_entity) {
    _tableBlueprint_columns_entity = [
      {
        key: 'KEY',
        title: 'KEY',
        sortable: true,
        filterable: true,
        searchable: false,
        extraClassTh: 'uu-text-nowrap',
        tdCb: (row, k, col_index, row_index) => {
          const entity = row;
          let id = null;
          if (typeof cbEntityKeyExtractor === 'function') {
            id = cbEntityKeyExtractor(entity);
          }
          return (<JSDisplayValue val={id} />);
        },
      },
      {
        key: 'ENTITY',
        title: 'ENTITY',
        sortable: false,
        filterable: false,
        searchable: false,
        extraClassTh: 'uu-text-nowrap',
        tdCb: (row, row_index, col_index) => { return (<JSDisplayValue val={row} />); },
      },
    ];
  }
  let _tableBlueprint_columns_4 = table_additional_column_keys;
  /*
  if (typeof view_to_table_mapCb === 'function') {
    _tableBlueprint_columns_4 = table_additional_column_keys.map(view_to_table_mapCb);
  }
  */
  if (typeof cbEntityColumnValExtractor === 'function') {
    // val = cbEntityColumnValExtractor(entity, key);
    _tableBlueprint_columns_4 = table_additional_column_keys.map((column_key) => {
      const col_blu = {
        key: column_key,
        title: _zzsurvey_utils_translate(column_key),
        sortable: true,
        filterable: true,
        searchable: false,
        tdCb: (row, k, col_index, row_index) => {
          const val = cbEntityColumnValExtractor(row, k);
          const val_to_display = _zzsurvey_utils_fix_val_for_display_in_table(k, val);
          if (typeof cbEntityColumnValCustomDisplay === 'function') {
            const _val_custome_display = cbEntityColumnValCustomDisplay(k, val_to_display);
            if (_val_custome_display) {
              return _val_custome_display;
            }
          }
          // else // will be default val display
          return (<JSDisplayValue val={val_to_display} />);
          // return val;
        },
      };
      return col_blu;
    });
  }
  //
  const tableBlueprint_columns = [
    {
      key: 'No',
      title: '#',
      sortable: false,
      filterable: false,
      searchable: false,
      tdCb: (row, k, col_index, row_index) => { return (row_index + 1); },
    },
    {
      key: 'Actions',
      title: 'Actions',
      sortable: false,
      filterable: false,
      searchable: false,
      extraClassTh: 'uu-text-wrap',
      tdCb: (row, k, col_index, row_index) => {
        // return 'cbEntityActionsJsx';
        const entity = row;
        return typeof cbEntityActionsJsx === 'function' ? (cbEntityActionsJsx(entity)) : (null)
      },
    },
    ..._tableBlueprint_columns_entity,
    ..._tableBlueprint_columns_4,
  ];

  // convert data to shallow (keyval pairs) Array of Objects for sorting and filtering table
  let arrFixed = arr;
  if (typeof cbEntityColumnValExtractor === 'function') {
    arrFixed = arr.map((entity, row_index) => {
      const fixed_entity = {
        ...entity,
      };
      table_additional_column_keys.forEach((key) => {
        const val = cbEntityColumnValExtractor(entity, key);
        fixed_entity[key] = val;
      });
      return fixed_entity;
    });
  }


  return (
    <>
      <div className="view-generator-simple">
        <TableGenerator
          tableBlueprint={{
            freshness: null,
            general: {
              pagination_enabled: true,
              pagination_rowsPerPageInitial: 10,
            },
            table: {
              showFilterRow: true,
              // showSelectable: false,
              showSelectable: showSelectable,
              showSelectableSingular: false,
              showSelectAll: true, // default true
              // extraClass: 'alien-mui-table__table uu-text-nowrap',
              extraClass: 'frfr-table__table uu-text-nowrap frfr-table__table--alien-mui-basic-table',
            },
            defaultColumnBlueprint: {
              sortable: true,
              filterable: true,
              searchable: false,
              tdCb: (row, col_key, col_index, row_index) => { return (<JSDisplayValue val={row?.[col_key]} />); },
            },
            columns: tableBlueprint_columns,
            row: {
              rowKeyExtractorCb: cbEntityKeyExtractor,
              ...table_additional_row_blueprint,
            },
          }}
          fetching={fetching}
          jsxSpinner={jsxSpinner}
          rowsData={arrFixed}
          widgetExtraClass={'frfr-table-generator__pack--alien-mui-basic-table-widget'}
          tableContainerExtraClass={'uu-anytable__table-container--responsive'}
          tableExtraClass={''}
          cbOnSelectionChange={props.cbOnSelectionChange}
        />
      </div>
    </>
  );

  return (
    <>
      <div className="view-generator-simple">
        {/*<div>ViewGeneratorSimple</div>*/}
        <div className="frfr-table-generator__pack alien-mui-table__pack alien-mui-table__pack--responsive">
          <div className="frfr-table-generator__table-container alien-mui-table__pack__table-wrapper">
            <table className="frfr-table-generator__table alien-mui-table__table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Actions&nbsp;</th>
                  {
                    is_show_entity && (
                      <th>KEY</th>
                    )
                  }
                  {
                    is_show_entity && (
                      <th>ENTITY</th>
                    )
                  }
                  <th></th>
                  {
                    table_additional_column_keys.map((key) => { return (<th>{key}</th>); })
                  }
                </tr>
              </thead>
              <tbody>
                {
                  arr.map((_entity, index) => {
                    let entity = {};
                    if (js_utils.is_object(_entity)) {
                      entity = _entity;
                    }
                    let id = null;
                    if (typeof cbEntityKeyExtractor === 'function') {
                      id = cbEntityKeyExtractor(entity);
                    }
                    return (
                      <tr key={id ? (id) : (index)}>
                        <td>{index + 1}</td>
                        <td className="view-generator-simple__actions">{
                          typeof cbEntityActionsJsx === 'function' ? (cbEntityActionsJsx(entity)) : (null)
                        }</td>
                        {
                          is_show_entity && (
                            <td><JSDisplayValue val={id} /></td>
                          )
                        }
                        {
                          is_show_entity && (
                            <td><JSDisplayValue val={entity} initialHorizontal={false} /></td>
                          )
                        }
                        <td></td>
                        {
                          table_additional_column_keys.map((key) => {
                            // return (<td>{entity[key]}</td>);
                            let val = entity[key];
                            if (typeof cbEntityColumnValExtractor === 'function') {
                              val = cbEntityColumnValExtractor(entity, key);
                            }
                            return (<td><JSDisplayValue val={val} initialHorizontal={false} /></td>);
                          })
                        }
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
          <div className="view-generator-simple__bellow-table">
            {
              fetching === true ? (
                <>{jsxSpinner}</>
              ) : (
                arr.length === 0 ? (
                  <div className="view-generator-simple__zero-items">No items to show</div>
                ) : (null)
              )
            }
            {jsxError}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewGeneratorSimple;